var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base_location_modal", {
    attrs: { tabs_advanced: _vm.tabs_add, tabs_remove: _vm.tabs_remove },
    scopedSlots: _vm._u([
      {
        key: "location_general_info",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [
            _c("sendpulse_general_tab", { attrs: { location: location } }),
          ]
        },
      },
      {
        key: "location_categories",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("sendpulse_fields_tab", { attrs: { location: location } })]
        },
      },
      {
        key: "title_location_categories",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("div", [_vm._v("Event Fields")])]
        },
      },
      {
        key: "sendpulse_bot_tab",
        fn: function (ref) {
          var location = ref.location
          var name = ref.name
          return [_c("sendpulse_bot_tab", { attrs: { location: location } })]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }